import React, {useState,useContext,createContext,useEffect,useRef,}  from 'react'
import {Form,Button,Container,Card,Alert,Modal,Navbar,Accordion} from 'react-bootstrap'
import axios from 'axios'
import {UserContext} from '../UserContext'
import uuid from 'react-uuid'

export default function Exhibits() {

    const {accountingData,setAccountingData}=useContext(UserContext)
    const {activeTab,setActiveTab}=useContext(UserContext)
    const {exhibits,setExhibits}=useContext(UserContext)
    const [show,setShow]=useState(false)
    const {exhibitionExhibits,setExhibitionExhibits}=useContext(UserContext)
    const {exhibitionExhibitsLocal,setExhibitionExhibitsLocal}=useContext(UserContext)
    const {exhibition,setExhibition,loadAllExhibits}=useContext(UserContext)
    const {sendForm}=useContext(UserContext)



    const search=(s)=>{
        if (s.trim().length==0){
            setExhibitionExhibitsLocal([...exhibitionExhibits])
        }else{
            const ss=s.toUpperCase()
            const results1=exhibitionExhibits.filter(item=>item.ETA30DESCRIPTION.toUpperCase().replace('΄','').includes(ss) || item.ETA30ALTDESCRIPTION.toUpperCase().replace('΄','').includes(ss))
            var results=[...results1]
            console.log(results)
            results1.forEach(item=>{
                var xres=exhibitionExhibits.filter(xitem=>xitem.sn==item.ParentID)
                //console.log([...xres])
                xres.forEach(xresitem=>{
                    results.push(xresitem)
                })
            })

            setExhibitionExhibitsLocal([...new Set(results)])
            
        }
    }



    const checkExhibit=(c,ETA30CODE)=>{
        const xexhibitionExhibits=exhibitionExhibits

        const cvalue= c ? 1 : 0
        xexhibitionExhibits.forEach(e=>{
            if (e.ETA30CODE==ETA30CODE){
                e.Checked=cvalue
            }
        })
        setExhibitionExhibits([...xexhibitionExhibits])
    }

    const childExhibits=(pid)=>{
        const childExhibitsList=exhibitionExhibitsLocal.filter(item1=> item1.sn==pid || item1.ParentID==pid).sort((a,b)=>a.ETA30CODE.localeCompare(b.ETA30CODE)).map((item,index)=>{
            return(
                <Card key={item.ETA30CODE}>
                <Card.Body>

                <Card.Text>
                <input type="checkbox" checked={item.Checked==1} value={item.ETA30CODE} onChange={(e)=>checkExhibit(e.target.checked,item.ETA30CODE)}/>
                &nbsp;
                {item.ETA30DESCRIPTION} // {item.ETA30ALTDESCRIPTION}
    
                </Card.Text>
                </Card.Body>
                </Card>                
            )            
        })

        return childExhibitsList
        
    }

    const exhibitsList=exhibitionExhibitsLocal.map((item,index)=>{
        const eta30code=item.ETA30CODE

        var count=0
        childExhibits(item.sn).forEach(x=>{
            count=count+exhibitionExhibits.filter(y=>y.ETA30CODE==x.key && y.Checked==1).length
        })
       
        return(
            <>
            {item.ParentID==0 &&

                <Accordion.Item eventKey={index} key={index} >
                <Accordion.Header><b><font color={count>0 ? 'red' : ''}>{item.ETA30CODE} // {item.ETA30DESCRIPTION} // {item.ETA30ALTDESCRIPTION}</font> </b>&nbsp; {count} / {childExhibits(item.sn).length}</Accordion.Header>
                <Accordion.Body>
                    {childExhibits(item.sn)}
                </Accordion.Body>
                </Accordion.Item>

                
            }
            </>
            


        )
    })



  return (
        <Container fluid>
        <>
        {/* <button onClick={()=>console.log(exhibitionExhibits)}>123</button> */}
        <Alert variant='success'>
          <h4>ΕΚΘΕΜΑΤΑ // EXHIBITS {accountingData.CMACTIVITYID} {exhibition.GLX_ExCode}</h4>
          </Alert>

          <Form.Control type="text" placeholder='Search....' onChange={(e)=>search(e.target.value)}/>
            <br/>
            <Accordion>
          {exhibitsList}
          </Accordion>

          <>  
            <br/><br/><br/><br/>
            <Navbar bg="light" fixed="bottom" >
                <table width="100%"><tbody><tr>
                  
                  <td align="left">
                    {accountingData.CMTIN && 
                      <Button variant="secondary" onClick={()=>sendForm(1)}>ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ // TEMPORARY SAVE</Button>
                    }
                
  
              </td>  <td align="right">
                <Button  variant="secondary" onClick={()=>{window.scroll(0,0);setActiveTab('firms')}}>ΠΙΣΩ // BACK</Button>
                &nbsp;
                <Button  variant="success" onClick={()=>{window.scroll(0,0);setActiveTab('stands')}}>ΕΠΟΜΕΝΟ // NEXT</Button>
                </td></tr></tbody></table>
            </Navbar> 
            </>

            </>



        </Container>
  )
}
